import { AboutVoopter } from "Components/organisms/AboutVoopter";
import { AppBanner } from "Components/organisms/AppBanner";
import { AccordionInfoTemplate } from "Components/templates/AccordionInfo";
import { ALERTS_FAQ_ADS } from "shared/config/adSlots";
import { InfoWidth } from "pages/Alerts/styles";

/**
 * Seções exibidas abaixo do conteúdo principal das telas de alertas:
 * banner do app, FAQ com anúncios e "Sobre a Voopter".
 * Mesmos componentes e ordem da lista de alertas em `/alertas`.
 */
export const AlertsInfoSections: React.FC = () => (
  <>
    <AppBanner />
    <InfoWidth>
      <AccordionInfoTemplate centered ads={ALERTS_FAQ_ADS} desktopAdFrom="xl" />
    </InfoWidth>
    <AboutVoopter />
  </>
);
